import React from 'react';

const GlobalConfigFormModal = React.lazy(() => import('../components/FormModal'));
const globalConfigModalRegistry = {
    core_globalConfigId: GlobalConfigFormModal
};
export default globalConfigModalRegistry;
